import { C } from "@/helpers/global";

export default {
    namespaced: true,
    state: () => ({
        list: [],
    }),
    mutations: {
        setListItem(state, data) {
            for (const r of state.list) {
                if (r.id == data.id) {
                    Object.assign(r, data);
                    break;
                }
            }
        },
        setList(state, data) {
            for (let i = 0; i < data.length; i++) {
                let isIn = false;
                for (const r of state.list) {
                    if (r.id == data[i].id) {
                        Object.assign(r, data[i]);
                        isIn = true;
                        break;
                    }
                }
                if (!isIn) {
                    state.list.push(data[i]);
                }
            }
        },
        setListReaded(state, data) {
            state.list.forEach((r) => {
                if (data > 0) {
                    if (r.id <= data) {
                        r.isReaded = true;
                    }
                }
                else {
                    r.isReaded = true;
                }
            });
            //appData.fn.setSession(StoreMessage.state.list, state.list);
        },
    },
    actions: {
        setListItem(ctx, data) {
            ctx.commit("setListItem", data);
        },
        setList(ctx, data) {
            ctx.commit("setList", data);
        },
        setListReaded(ctx, data) {
            ctx.commit("setListReaded", data);
        },
    },
    getters: {
        getListEndId: (state) => (isStudent, userId) => {
            const l = state.list.filter((r) => {
                 if (isStudent) {
                    return C.Bool(r.isStudent) === false
                        && C.Int(r.teacherId) === userId
                        && C.Bool(r.isReaded) === false;
                }
                return C.Bool(r.isStudent) === true
                    && C.Int(r.studentId) === userId
                    && C.Bool(r.isReaded) === false;
            });
            if (l.length === 0) { return 0; }
            const endId = l.reduce((max, r) => {
                return r.id > max ? r.id : max;
            }, l[0].id);
            return endId;
        },
        getEndDateUnReaded: (state) => (isStudent) => {
            const l = state.list.filter((r) => {
                if (isStudent) {
                    return C.Bool(r.isStudent) == false && C.Bool(r.isReaded) == false;
                }
                return C.Bool(r.isStudent) == true && C.Bool(r.isReaded) == false;
            });
            if (l.length === 0) { return null; }
            const maxDate = l.reduce((max, r) => {
                return r.createdDate > max ? r.createdDate : max;
            }, l[0].createdDate);
            return maxDate;
        },
        getEndDateUnReadedUser: (state) => (isStudent, userId) => {
            const l = state.list.filter(r => {
                if (isStudent) {
                    return C.Bool(r.isStudent) === false
                        && C.Int(r.teacherId) === userId
                        && C.Bool(r.isReaded) === false;
                }
                return C.Bool(r.isStudent) === true
                    && C.Int(r.studentId) === userId
                    && C.Bool(r.isReaded) === false; 
            });

            if (l.length === 0) { return null; }
            const maxDate = l.reduce((max, r) => {
                return r.createdDate > max ? r.createdDate : max;
            }, l[0].createdDate);
            return maxDate;
        },
        //getEndDateUnReadedStudent: (state) => (studentId) => {
        //    const l = state.list.filter((r) => {
        //        return C.Bool(r.isStudent) == true && C.Int(r.studentId) == studentId && C.Bool(r.isReaded) == false;
        //    });
        //    if (l.length === 0) { return null; }
        //    const maxDate = l.reduce((max, r) => {
        //        return r.createdDate > max ? r.createdDate : max;
        //    }, l[0].createdDate);
        //    return maxDate;
        //},
        getCountUnReaded: (state) => (isStudent) => {
            return state.list.filter((r) => {
                if (isStudent) {
                    return C.Bool(r.isStudent) == false && C.Bool(r.isReaded) == false;
                }
                return C.Bool(r.isStudent) == true && C.Bool(r.isReaded) == false;
            }).length;
        },
        getCountUnReadedUser: (state) => (isStudent, userId) => {
            return state.list.filter(r => {
                if (isStudent) {
                    return C.Bool(r.isStudent) === false
                        && C.Int(r.teacherId) === userId
                        && C.Bool(r.isReaded) === false;
                }
                return C.Bool(r.isStudent) === true
                    && C.Int(r.studentId) === userId
                    && C.Bool(r.isReaded) === false;
            }).length;
        },
        //getCountUnReadedStudent: (state) => (studentId) => {
        //    return state.list.filter((r) => {
        //        return C.Bool(r.isStudent) == true && C.Int(r.studentId) == studentId && C.Bool(r.isReaded) == false;
        //    }).length;
        //},
        //getListUnReaded: (state) => (studentId) => {
        //    const l = state.list;
        //    if (studentId > 0) {
        //        return l.filter((r) => C.Bool(r.isReaded) == false).sort((a, b) => a.createdDate.getTime() - b.createdDate.getTime()).filter((r) => {
        //            return C.Int(r.studentId) == studentId;
        //        });
        //    }
        //    return l.filter((r) => C.Bool(r.isReaded) == false).sort((a, b) => a.createdDate.getTime() - b.createdDate.getTime());
        //},
        getListAll: (state) => (isStudent, userId) => {
            let l = state.list.filter((r) => {
                if (isStudent) {
                    return C.Int(r.teacherId) == userId;
                }
                return C.Int(r.studentId) == userId;
            });
            return l;
        },
    }
};
